import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createColor } from '../../api/COLORS/colors';
import { toast } from 'react-toastify';

export const useCreateColor = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createColor,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['colors'] });
            toast.success('Couleur créée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la création de la couleur');
        },
    });
};
